export default __webpack_public_path__ + "static/media/KOREAN_VALUE_BOX.6f1f0f1c.png";